<div class="hems-container flex flex-col">
  <div data-at-hems-dashboard-header class="dashboard-header">
    <h1>
      {{ '+INSTALLATIONS.INSTALLATION.HEMS.DASHBOARD' | translate }}
    </h1>
    <ng-container
      *ngrxLet="{
        isSettingsVisible: isSettingsVisible$ | async,
        hemsSubscription: hemsSubscription$ | async
      } as feature"
    >
      <button
        *ngIf="
          feature.isSettingsVisible &&
          (feature.hemsSubscription === hemsType.Full || feature.hemsSubscription === hemsType.Lite)
        "
        class="settings-btn"
        data-at-hems-settings-button
        mat-stroked-button
        color="secondary"
        gtm="onOpen"
        gtmAction="Settings"
        gtmCategory="hems"
        (click)="openSettingsOverlay()"
      >
        <mat-icon>settings</mat-icon>
        <span>{{ '+HEMS.SETTINGS.TITLE' | translate }}</span>
      </button>
    </ng-container>
  </div>
  <app-energy-flow></app-energy-flow>
  <app-energy-history-chart></app-energy-history-chart>
</div>
